import React from "react";
import { Box } from "@mui/material";

const TabPanel = (props) => {
  const { children, value, index } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
};

export default TabPanel;
